var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"splide",attrs:{"role":"group","id":_vm.uUID}},[_c('div',{staticClass:"splide__track"},[_c('ul',{staticClass:"splide__list"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }